const landing_page = {
  aboutUs: "Über uns", // translated
  topPackages: "Top-Pakete", // translated
  featuredHotels: "Ausgewählte Hotels", // translated
  topTours: "Top-Touren", // translated
  whatOurMembersSay: "Was unsere Mitglieder sagen...", // translated
  followUsOnInstagram: "Folge uns auf Instagram", // translated
  pleaseWait: "Warten Sie mal...", // translated
  packages: "Pakete", // translated
  learnMore: "Erfahren Sie mehr", // translated
  trustedCarHirePartners: "Vertrauenswürdige Autovermietungspartner", // translated
  ourPartners: "Unsere Partner", // translated
};


export default landing_page;
